import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const TabsContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.05),
              -2px -2px 5px rgba(255, 255, 255, 0.8);
`;

const TabButton = styled.button`
  flex: 1;
  background: ${props => props.$active ? 'linear-gradient(145deg, #4a6fa1, #5d82b3)' : '#f0f3f9'};
  color: ${props => props.$active ? '#ffffff' : '#4a6fa1'};
  border: none;
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover, &:focus {
    background: ${props => props.$active ? 'linear-gradient(145deg, #4a6fa1, #5d82b3)' : '#e6ebf5'};
  }
  
  &:active {
    box-shadow: inset 1px 1px 3px rgba(0, 0, 0, 0.1),
                inset -1px -1px 3px rgba(255, 255, 255, 0.9);
  }
`;

const StatisticsTabs = ({ currentType, onTypeChange }) => {
  const { t } = useTranslation();

  return (
    <TabsContainer>
      <TabButton
        $active={currentType === 'income'}
        onClick={() => onTypeChange('income')}
      >
        {t('income')}
      </TabButton>
      <TabButton
        $active={currentType === 'expenses'}
        onClick={() => onTypeChange('expenses')}
      >
        {t('expenses')}
      </TabButton>
    </TabsContainer>
  );
};

export default StatisticsTabs;